import FanNotificationPage from "./FanNotificationPage";

export default FanNotificationPage;
